// ignore-string-externalization
import type { ErrorEvent, EventHint } from '@sentry/types';
import { knownIssues } from './knownIssues';

export function beforeSend(
  event: ErrorEvent,
  _hint: EventHint,
): ErrorEvent | null {
  for (const issue of knownIssues) {
    if (issue.match(event)) {
      event.fingerprint = [issue.id];
      event.level = issue.level;
      event.tags = { ...event.tags, known_issue: issue.id };
      event.contexts = {
        ...event.contexts,
        known_issue: {
          id: issue.id,
          description: issue.description,
          resolved_by: issue.resolvedBy,
          grouped_in_code: true,
        },
      };
      return event;
    }
  }
  return event;
}
